import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {UserAddressStore} from "../../../../../../client/state/UserAddressStore";
import {PlusIcon} from "../../../../../../core/ui/SVGElements.jsx";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme";
import {NOOP_FUNCTION} from "../../../../../../stem-core/src/base/Utils";
import {StyleSheet} from "../../../../../../stem-core/src/ui/Style";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {MakeMerchantUserResourcesAccessLink} from "../../../../../common/MerchantUserResourcesAccessLink";
import {RadioListInput} from "../../../../../../core/ui/input/radio/RadioListInput.jsx";
import {LinkButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Messages} from "../../../../../Messages.js";
import {Flow} from "../../../../flows/Flow.js";


class ChooseAddressComponentStyle extends StyleSheet {
    @styleRule
    addNewAddress = {
        color: this.themeProps.LINK_COLOR,
        width: "fit-content",
        cursor: "pointer",
        fontWeight: this.themeProps.FONT_WEIGHT_REGULAR,
        whiteSpace: "nowrap",
        marginTop: "1.55rem",
        display: "inline-block",
        ">*": {
            opacity: 0.8,
            display: "inline-block",
        },
        ":hover>*": {
            opacity: 1,
        },
        " g": {
            fill: this.themeProps.LINK_COLOR,
        },
        ">:last-child": {
            marginLeft: 12,
        },
        ">:first-child": {
            transform: "translateY(1px)",
        },
    };

    @styleRule
    addressDetails = {
        display: "flex",
        flexDirection: "column",
    };

    @styleRule
    nameOnAddress = {
        marginBottom: 4,
    };

    @styleRule
    addressItem = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
    };
}

@registerStyle(ChooseAddressComponentStyle)
export class ChooseAddressComponent extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            onChange: NOOP_FUNCTION,
        }
    }

    render() {
        const {styleSheet} = this;
        const extraAddressCount = iFrameUserDataService.getExtraUserAddressCount();

        const addressFormatter = (userAddress) => <div className={styleSheet.addressItem}>
            <div className={styleSheet.nameOnAddress}>{userAddress.getRecipientName()}</div>
            <div className={styleSheet.addressDetails}>{userAddress}</div>
        </div>;

        return [
            <RadioListInput
                onChange={(value) => this.handleListItemSelect(value)}
                entries={UserAddressStore.all()}
                initialValue={Flow.address.selectedValue}
                formatter={addressFormatter}
            />,
            <LinkButton className={styleSheet.addNewAddress} onClick={() => Flow.address.enterNewValue()}>
                <PlusIcon size={12.25}/>
                <span>{Messages.addNewAddress}</span>
            </LinkButton>,
            MakeMerchantUserResourcesAccessLink(extraAddressCount),
        ];
    }

    isValid() {
        return this.getAddress() != null;
    }

    getAddress() {
        return Flow.address.selectedValue;
    }

    handleListItemSelect(address) {
        Flow.address.update({selectedValue: address});
        this.options.onChange();
    }

    onMount() {
        this.attachListener(Flow.address, () => this.redraw());
    }
}
